import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  AuthLayout,
  Login,
  LoginByPhoneNo,
  Signup,
  SMSVerify,
  CompleteRegistragion,
  ForgetPassword,
  ChangePassword,
} from './routeList';
const notAuthenticatedRouter = [
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: <Navigate to='login' replace />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'otp-login',
        element: <LoginByPhoneNo />,
      },
      {
        path: 'otp-login/verify',
        element: <SMSVerify />,
      },
      {
        path: 'signup',
        element: <Signup />,
      },
      {
        path: 'signup/verify',
        element: <SMSVerify />,
      },
      {
        path: 'signup/complete-registration',
        element: <CompleteRegistragion />,
      },
      {
        path: 'forget-password',
        element: <ForgetPassword />,
      },
      {
        path: 'change-password',
        element: <ChangePassword />,
      },
      { path: '*', element: <Navigate to='/login' /> },
    ],
  },
];

export default notAuthenticatedRouter;
